export default function isValidHTMLElement(mountNode) {
  return mountNode && mountNode.nodeType === 1;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/style-container/node_modules/fela-utils/es/isValidHTMLElement.js
// module id = 1081
// module chunks = 0